import { type Dispatch, useMemo } from 'react';

import type {
  CreateEstimationRequest,
  CreateProjectRequest,
  EstimationModelResponse,
  EstimationUserAssignmentResponse,
  MethodologyResponse,
  ProjectWithEstimationResponse,
} from '@/api/schema/data-contracts';
import { type Actions, eActionTypes } from '@/context/estimationContext/model.ts';
import type { PhaseResponse } from '@/types';
import type { AdditionalField } from '@/types';

export const useActions = (dispatch: Dispatch<Actions>) =>
  useMemo(
    () => ({
      setEstimation: (payload: Partial<CreateEstimationRequest>) => {
        dispatch({ type: eActionTypes.SET_ESTIMATION, payload });
      },
      setSelectedEstimationModel: (payload: EstimationModelResponse | null) => {
        dispatch({ type: eActionTypes.SET_SELECTED_ESTIMATION_MODEL, payload });
      },
      setMethodologies: (payload: MethodologyResponse[]) => {
        dispatch({ type: eActionTypes.SET_METHODOLOGIES, payload });
      },
      setPhaseResponses: (payload: Partial<PhaseResponse[]>) => {
        dispatch({ type: eActionTypes.SET_PHASE_RESPONSES, payload });
      },
      setProject: (payload: Partial<CreateProjectRequest>) => {
        dispatch({ type: eActionTypes.SET_PROJECT, payload });
      },
      setSavedEstimation: (payload: ProjectWithEstimationResponse) => {
        dispatch({ type: eActionTypes.SET_SAVED_ESTIMATION, payload });
      },
      setEstimationUserAssignments: (payload: EstimationUserAssignmentResponse[]) => {
        dispatch({ type: eActionTypes.SET_ESTIMATION_USER_ASSIGNMENTS, payload });
      },
      setPlanningResponsibleId: (payload: string) => {
        dispatch({ type: eActionTypes.SET_PLANNING_RESPONSIBLE_ID, payload });
      },
      setProjectReviewerId: (payload: string) => {
        dispatch({ type: eActionTypes.SET_PROJECT_REVIEWER_ID, payload });
      },
      setAdditionalContributors: (payload: string[]) => {
        dispatch({ type: eActionTypes.SET_ADDITIONAL_CONTRIBUTORS, payload });
      },
      setAdditionalFields: (payload: AdditionalField[]) => {
        dispatch({ type: eActionTypes.SET_ADDITIONAL_FIELDS, payload });
      },
      setDetailedEstimationId: (payload: string) => {
        dispatch({ type: eActionTypes.SET_DETAILED_ESTIMATION_ID, payload });
      },
      removeAdditionalField: (payload: string) => {
        dispatch({ type: eActionTypes.REMOVE_ADDITIONAL_FIELD, payload });
      },
      resetEstimationState: () => {
        dispatch({ type: eActionTypes.RESET_ESTIMATION_STATE });
      },
    }),
    [dispatch],
  );
